module.exports = __webpack_public_path__ + "static/media/Fridge.91365e3c.jpg";